<template>
  <div class="card shadow mb-4">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 v-if="current_page=='Substations'" class="m-0 font-weight-bold">{{ $t('System_data') }} ({{ $t('Battery') }})</h6>
      <h6 v-else class="m-0 font-weight-bold">{{ $t('Battery_data') }}</h6>
      <div class="form-inline"> 
        <div class="form-group">
          <label class="mr-3" for="select">Ver:</label>
          <select @change="onChange($event)" name="select" id="select-batterysamples" class="form-control custom-select">
            <option value="all" :selected="fields.length > 1">{{ $t("All") }}</option>
            <!-- <option value="I">Corrente (I)</option>
            <option value="PF">Fator de potência (PF)</option>
            <option value="S">Potência aparente (S)</option> -->
            <option v-if="fields.includes('inverterActivePowerAggAvg')" :selected="fields.length == 1" value="P">{{ $t("Active_power") }} (P)</option>
            <option v-if="fields.includes('inverterReactivePowerAggAvg')" :selected="fields.length == 1" value="Q">{{ $t("Reactive_power") }} (Q)</option>
            <!--<option v-if="fields.includes('inverterReactivePowerAvg')" :selected="fields.length == 1" value="V">{{ $t("Voltage") }} (V)</option>
            <option v-if="fields.includes('inverterReactivePowerAvg')" :selected="fields.length == 1" value="I">{{ $t("Current_electricty") }} (I)</option>
            <option v-if="fields.includes('inverterReactivePowerAvg')" :selected="fields.length == 1" value="S">{{ $t("Apparent_power") }} (S)</option>
            <option v-if="fields.includes('inverterReactivePowerAvg')" :selected="fields.length == 1" value="PF">{{ $t("Power_factor") }} (PF)</option> -->
          </select>
        </div>
      </div>
    </div>
    <div class="card-body text-center">
      <LoadingSpinner v-if="loading"></LoadingSpinner>
      <div v-show="!loading" id="canvas-batterysampleschart"></div>
      <!-- <div id="canvas-sampleschart"></div> -->
    </div>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'BatterySamplesChart',
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      chart: null,
      selected_option: "all",
      fields: [],
      previous_selected_option: 'all',
      rename: {
        "bmsCellVoltageAvg": "V",
        "inverterActivePowerAggAvg": "P",
        "inverterReactivePowerAggAvg": "Q"
      }
    }
  }, 
  mounted: function(){
    const chart_options = {
        chart: {
          zoomType: '',
          backgroundColor: '#fff'
        },
        title: {
          text: null
        },
        credits: { enabled: false },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
              day: '%a, %e %b'
          }
        },
        yAxis: {
          title: {
            text: '',
            rotation: 0,
          }
        },
        legend: {
          enabled: true
        },
        tooltip: {
          shared: true,
          xDateFormat: '%A, %d %b, %H:%M',
          pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.3f}</b>'
        },
        plotOptions: {
          area: {
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [
                [0, Highcharts.getOptions().colors[0]],
                [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
              ]
            },
            marker: {
              radius: 2
            },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            threshold: null
          },
          series: {
            connectNulls: false,
            marker: {
              enabled: false
            }
          },
        },
      series: []
    }

    this.chart = Highcharts.chart('canvas-batterysampleschart', chart_options)
  },
  methods: {
    onChange: function(event) {
      this.selected_option = event.target.value
    },
/*     set_values_flatten: function() {
      if (this.data.length == 0) {
        if (this.chart.series && this.chart.series.length)
          while (this.chart.series.length) this.chart.series[this.chart.series.length-1].remove()
        return
      }

      let fields_to_ignore = ["datetime", "measure_cons", "F"]
      const timezone = this.$store.getters.timezone
    }, */
    set_values: async function(){
      if (this.data.length == 0) {
        if (this.chart.series && this.chart.series.length)
          while (this.chart.series.length) this.chart.series[this.chart.series.length-1].remove()
        return
      }
      
      this.fields = []
      const batteries = this.data[0].batteries

      const timezone = this.$store.getters.timezone
      while (this.chart.series.length > 0) this.chart.series[0].remove(true)
      let samples = {}
      let fields = []
      batteries.forEach(b => {
        samples[b.name] = []
        b.samples.forEach(r => {
          let output = this.flatten(r)
          samples[b.name].push(output)
          fields = []
          let fields_all = Object.keys(output)
          for (let f of fields_all) {
            //if (!['_id._bsontype', '_id', 'bmsSocTrimmedAvg', 'bess_manager_error', 'bess_manager_setpoints', 'bess_manager_api_response_ok', 'timestamp', '_id.id', 'producer', 'device', 'data', 'mode', 'state'].includes(f) && !f.match(/data.\d+$/g)) {
            if (["inverterActivePowerAggAvg", "inverterReactivePowerAggAvg"].includes(f)) {
              fields.push(f)
              this.fields.push(f)
              this.fields = this.fields.filter((value, index, self) => self.indexOf(value) === index)
            }
          }    
        })
        
        //if (this.chart.series.length == 0) {
          //let flag = 0
          for (let f of fields) {   
            const name_prepend = b.name == "" ? "" : `${b.name}.`    
            this.chart.addSeries({
              name: `${name_prepend}${this.rename[f]}`,
              type: 'spline',
              /* visible: flag ? false : true, */
              data: samples[b.name].map(s => [moment.tz(s.timestamp || s.datetime, timezone).valueOf(), parseFloat(s[f])]),
            }, false)
            //flag = 1
          }  
        //} 
        /* else {
          let ix = 0
          for (let f of fields) {       
            this.chart.series[ix].setData(samples[b.name].map(s => [moment.tz(s.timestamp, timezone).valueOf(), parseFloat(s[f])]))
            ix = ix + 1
          }  
        } */

      })
      await new Promise((resolve, reject) => {
        setTimeout(() => {
          this.chart.redraw()
          this.selected_option = 0
          resolve()
        }, 0)
      })
     
      //console.log("changing to", this.previous_selected_option)
      this.selected_option = $("#select-batterysamples").val() //this.previous_selected_option
    },
    flatten: function(target, opts){
      opts = opts || {}
       
      var delimiter = opts.delimiter || '.'
      var maxDepth = opts.maxDepth
      var output = {}
       
      function step (object, prev, currentDepth) {
        currentDepth = currentDepth || 1
        Object.keys(object).forEach(function (key) {
          var value = object[key]
          var isarray = opts.safe && Array.isArray(value)
          var type = Object.prototype.toString.call(value)
          var isobject = (
            type === '[object Object]' ||
            type === '[object Array]'
          )
      
          var newKey = prev
            ? prev + delimiter + key
            : key
      
          if (!isarray && isobject && Object.keys(value).length &&
            (!opts.maxDepth || currentDepth < maxDepth)) {
            return step(value, newKey, currentDepth + 1)
          }
      
          output[newKey] = value
        })
      }
      
      step(target)
      return output
    }
  },
  computed:{
    data: function(){
      return this.$store.getters.data
    },
    current_page: function(){
      return this.$route.name
    }, 
    loading: function(){
      return this.$store.getters.data_loading
    }
  },
  watch:{
    data: function(){
      //console.log(this.data)
      this.set_values()
    },
    selected_option: function() {
      //console.log("Triggered", this.selected_option)
      if (!this.selected_option) return
      this.previous_selected_option = this.selected_option

      this.chart.tooltip.update({ pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.3f}</b>'})
      this.chart.yAxis[0].update({ title: { text: '' } })

      this.chart.series.forEach((s, i) => {
        if (this.selected_option == "all") {
          this.chart.series[i].update({ showInLegend: true })
          this.chart.series[i].update({ visible: true })
          this.chart.yAxis[0].update({ title: { text: '' } })
          this.chart.tooltip.update({ pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.3f}</b>'})
          //if (i == 0) this.chart.series[i].update({ visible: true })
          return
        }

        /* this.chart.tooltip.update({ pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.3f}</b>'})
        this.chart.yAxis[0].update({ title: { text: '' } }) */

        if ( /* Hide not selected */
          s.name != `L1.${this.selected_option}` && 
          s.name != `L2.${this.selected_option}` && 
          s.name != `L3.${this.selected_option}` &&
          s.name != this.selected_option) {
          this.chart.series[i].update({ showInLegend: false })
          this.chart.series[i].update({ visible: false })
        }
        else { /* Show selected */
          switch (this.selected_option) {
            case "V": {
              this.chart.yAxis[0].update({ title: { text: 'V' } })
              this.chart.tooltip.update({ pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.3f} V</b>'})
              break
            }
            case "I": {
              this.chart.yAxis[0].update({ title: { text: 'A' } })
              this.chart.tooltip.update({ pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.3f} A</b>'})
              break
            }
            case "P": {
              this.chart.yAxis[0].update({ title: { text: 'kW' } })
              this.chart.tooltip.update({ pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.2f} kW</b>'})
              break
            }
            case "PF": {
              this.chart.yAxis[0].update({ title: { text: '' } })
              this.chart.tooltip.update({ pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.3f}</b>'})
              break
            }
            case "Q": {
              this.chart.yAxis[0].update({ title: { text: 'kVAr' } })
              this.chart.tooltip.update({ pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.3f} kVAr</b>'})
              break
            }
            default: {
              this.chart.yAxis[0].update({ title: { text: 'kW' } })
              this.chart.tooltip.update({ pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.2f} kW</b>'})
              break
            }
          }
          this.chart.series[i].update({ showInLegend: true })
          this.chart.series[i].update({ visible: true })
        } 
      })
      this.chart.redraw()
      return 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
